<template>
    <div>
        <van-popup position="bottom" v-model="isShow" @click-overlay="onCancel">
            <van-picker show-toolbar :columns="list" :cancel-button-text="$t('message.cancel')" :confirm-button-text="$t('message.submit')" @cancel="onCancel" @confirm="onConfirm"/>
        </van-popup>
    </div>
</template>

<script>
    export default {
        props: ['list', 'show', 'type'],
        data() {
            return {
                isShow: this.show,
            }
        },
        methods: {
            onCancel() {
                this.isShow = false;
                this.$emit("cancel", this.isShow)
            },
            onConfirm(value, index) {
                this.isShow = false;
                this.$emit("cancel", this.isShow);
                let data = {};
                data = {
                    name: value.text,
                    id: value.label,
                };
                this.$emit("change", data);
            },
        },
    }
</script>
